import * as S from "./ExercisePartList.style";
import { Video } from "@/common/types/video";
import { Loading } from "@/components/atoms/Loading";
import { ExercisePartItem } from "@/components/atoms/ExercisePartItem";

interface ExercisePartListProps {
  videos: Video[];
  onClick: (videoId: string) => void;
  isLoading: boolean;
}

export const ExercisePartList = ({
  videos,
  onClick,
  isLoading,
}: ExercisePartListProps) => {
  if (isLoading) {
    return <Loading />;
  }

  return (
    <S.ExercisePartList>
      {videos.map((video: Video, idx: number) => {
        return <ExercisePartItem video={video} key={idx} onClick={onClick} />;
      })}
    </S.ExercisePartList>
  );
};
